<template>
  <div class="info-modal__content__title">
    <h4>{{ $t('modal_content.monthly_salary.title') }}</h4>
  </div>
  <div class="info-modal__content__text">
    {{ $t('modal_content.monthly_salary.text') }}
  </div>
</template>

<script setup lang="ts"></script>
